import React,{useEffect} from 'react';
import axios from 'axios';
function Career() {
   useEffect(() => {
      const backendUrl = import.meta.env.VITE_BACKEND_URL; // ✅ dynamic URL
      axios.post(`${backendUrl}/api/analytics/visit`, { page: "Career" })
        .then(res => console.log("Career visit recorded:", res.data))
        .catch(err => console.error("Analytics error:", err));
    }, []);
  return (
    
    <div className="bg-gray-100 py-8 px-4 font-serif">
      {/* Header Section */}
      <div className="text-center mb-12">
        <h1 className="text-2xl lg:text-4xl font-bold text-[#FF4902]">
          Careers at Mammoth Streetwear
        </h1>
      </div>

      {/* Main Content Section */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 ml-14">
        {/* Left Section */}
        <div>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">Join our Team</h2>
          <p className="text-gray-700 mb-6">
            Are you passionate about streetwear and inspired by urban culture? At Mammoth Streetwear, we're not just a clothing brand; we're a movement that celebrates individuality, creativity, and self-expression. Join us in shaping the future of streetwear while impacting fashion and culture.
          </p>

          <h2 className="text-2xl font-semibold text-gray-800 mb-4">Why Work With Us</h2>
          <ul className="text-gray-700 space-y-4 mb-6">
            <li>
              <strong>Innovative Environment:</strong> Join a creative team that thrives on pushing boundaries and setting trends.
            </li>
            <li>
              <strong>Collaborative Culture:</strong> We promote an open and inclusive workplace where ideas are shared, and every voice is valued.
            </li>
            <li>
              <strong>Growth Opportunities:</strong> Whether you’re just beginning your career or are already an industry professional, we offer pathways to enhance your skills and advance your career.
            </li>
            <li>
              <strong>Streetwear Enthusiast Haven:</strong> Dive into a culture where a passion for fashion intersects with the rhythm of urban style.
            </li>
          </ul>

          <h2 className="text-xl font-semibold mb-4">Don’t see a role that fits?</h2>
          <p className="text-gray-700 mb-4">
            We’re always on the lookout for talented individuals who share our passion for streetwear. Drop us an email at <a href="mailto:info@mammothstreetwears.com" className="text-blue-500 underline">info@mammothstreetwear.com</a> with your resume and portfolio. Let us know how you’d like to contribute to the team.
          </p>
          <h2 className="text-xl font-semibold mb-4">Perks and Benefits</h2>
          <ul className="list-disc list-inside space-y-2">
            <li>Competitive salary and benefits.</li>
            <li>Flexible working hours.</li>
            <li>Employee discounts on all Mammoth Streetwear products.</li>
            <li>Opportunities to attend industry events and collaborations.</li>
          </ul>
        </div>

        {/* Right Section */}
        <div className="bg-white-100 shadow-lg p-6 rounded-lg mr-14">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">Open Positions</h2>
          <ul className="text-gray-700 mb-6 space-y-4">
            <li>
              <strong>Graphic Designer</strong><br />
              <span className="block text-sm">Location: In-House</span>
              <span className="block text-sm">Responsibilities: Design bold and unique graphics for apparel, marketing, and social media.</span>
              <span className="block text-sm">Requirements: Proficiency in Adobe Creative Suite and a strong sense of urban aesthetic.</span>
            </li>
            <li>
              <strong>Social Media Manager</strong><br />
              <span className="block text-sm">Location: In-House</span>
              <span className="block text-sm">Responsibilities: Create and manage engaging content across platforms, interact with our community, and grow our online presence.</span>
              <span className="block text-sm">Requirements: Experience with social media strategy and a passion for streetwear culture.</span>
            </li>
            <li>
              <strong>E-Commerce Specialist</strong><br />
              <span className="block text-sm">Location: In-House</span>
              <span className="block text-sm">Responsibilities: Manage our online store, optimize product listings, and analyze data to enhance customer experience.</span>
              <span className="block text-sm">Requirements: Knowledge of e-commerce platforms and digital marketing.</span>
            </li>
            <li>
              <strong>Product Photographer & Videographer</strong><br />
              <span className="block text-sm">Location: In-House</span>
              <span className="block text-sm">Responsibilities: Having good skills of photography and videography. Should have skills to edit photos & videos (an advantage).</span>
              <span className="block text-sm">Requirements: 1-2 years of experience in photography and videography.</span>
            </li>
          </ul>
          <p className="text-gray-700 mb-4">
            For applying, please send an email to <a href="mailto:info@mammothstreetwears.com" className="text-blue-500 underline">info@mammothstreetwears.com</a> with your resume and a link or attachment of your portfolio. Ensure that the subject line of the email clearly states the position you are applying for. Thank you, and we will get back to you as soon as possible.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Career;
